module.exports = __webpack_public_path__ + "media/plate-38d1b298.svg";